<template>
  <div class="taste-combo">
    <div class="tuolele-main-box">
      <div class="data-form-title">设置套餐的具体内容</div>
      <el-form :model="comboObj" label-position="right" label-width="130px">
        <el-form-item label="套餐类型" required>
          <el-select
            v-model="comboObj.item_type"
            placeholder="请选择"
            :disabled="isCreate"
          >
            <el-option
              v-for="item in typeList"
              :key="item.value"
              :label="item.text"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="套餐实际销售价" required>
          <el-input
            size="large"
            placeholder="请输入"
            v-model="comboObj.total_price"
            :disabled="isCreate"
          ></el-input>
          <i>元</i>
        </el-form-item>
        <el-form-item label="设置体验课时" required>
          <el-input
            size="large"
            placeholder="请输入"
            v-model="comboObj.days"
            :disabled="isCreate"
          ></el-input>
          <i>天</i>
          <b>（跳过周末）</b>
        </el-form-item>
        <el-form-item label="套餐扣费方式">
          <span v-if="comboObj.item_type == 3 || comboObj.item_type == 4">月扣</span>
          <span v-if="comboObj.item_type == 30 || comboObj.item_type == 40">日扣</span>
        </el-form-item>
        <el-form-item v-if="!isCreate">
          <el-button type="primary" @click="saveCombo">生成套餐</el-button>
          <el-tooltip class="item" effect="dark" placement="top">
            <div slot="content">
              <p class="el-tooltip__popper-text">
                操作提示：
                <br />1、请点击“生成套餐”按钮，系统将为您自动显示套餐详情
                <br />2、点击“修改套餐”按钮，可以继续编辑套餐详情
                <br />3、确认无误后，即可点击“提交套餐”按钮，系统将根据套餐预览详情，正式生成套餐！
              </p>
            </div>
            <i class="el-icon-question"></i>
          </el-tooltip>
        </el-form-item>
      </el-form>
    </div>
    <div class="tuolele-main-box" v-if="isCreate">
      <div class="data-form-title">套餐详情预览</div>
      <div class="self-table">
        <div class="table-name">套餐名称 {{ comboShow.item_title }}</div>
        <div class="table-content">
          <table>
            <thead>
              <tr>
                <td>套餐类型</td>
                <td>扣费方式</td>
                <td>套餐课时</td>
                <td>套餐实际销售价</td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{{ fnGetText(comboObj.item_type) }}</td>
                <td>{{comboObj.item_type == 3 || comboObj.item_type == 4 ? "月扣": "日扣"}}</td>
                <td>{{ comboObj.days }}天</td>
                <td>{{ comboObj.total_price }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <el-button type="info" @click="isCreate = false">修改套餐</el-button>
        <el-button type="primary" @click="postCombo">提交套餐</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import Tool from '@/assets/js/tool.js'

export default {
  name: "tasteCombo",
  props: {
    type: [String, Number],
    item_title: String,
    limited_number: [String, Number],
    is_supplementary_agreement: [String, Number],
    grade_id: String
  },
  data() {
    return {
      typeList: [
        { text: "常规体验", value: "3" },
        { text: "假期体验", value: "4" },
        { text: "常规周末体验", value: "30" },
        { text: "假期周末体验", value: "40" }
      ],
      comboObj: {
        item_type: '3',
        days: '',
        total_price: ''
      },
      comboShow: {
        type: '',
        item_title: '',
        limited_number: '',
        grade_id: '',
        item_type: '',
        total_price: '',
        taste_day: '',
        taste_holiday: '',
        is_supplementary_agreement: '',
        original_price: ''
      },
      isCreate: false
    };
  },
  computed: {},
  mounted() {},
  methods: {
    fnGetText(val){
      var index = Tool.findIndexInArryByKeyVal(this.typeList, 'value', val)
      return this.typeList[index].text
    },
    saveCombo() {
      if (this.item_title == "") {
        this.$message({
          message: '套餐名称不能为空',
          type: 'warning'
        })
        return false;
      }
      if (this.grade_id == '') {
        this.$message({
          message:'请选择适用年级',
          type: 'warning'
        })
        return false;
      }
      let empty = false;
      for (const key in this.comboObj) {
        if (this.comboObj.hasOwnProperty(key)) {
          if (this.comboObj[key] == '') {
            empty = true;
          }
        }
      }
      if (empty) {
        this.$message({
          message: '请将套餐信息填写完整',
          type: 'warning'
        })
        return false;
      }
      this.comboShow.type = this.type
      this.comboShow.item_title = this.item_title
      this.comboShow.limited_number = this.limited_number
      this.comboShow.is_supplementary_agreement = this.is_supplementary_agreement
      this.comboShow.grade_id = this.grade_id
      this.comboShow.total_price = this.comboObj.total_price
      this.comboShow.item_type = this.comboObj.item_type
      this.comboShow.original_price = this.comboObj.total_price
      if (this.comboShow.item_type == 3) {
        this.comboShow.taste_day = this.comboObj.days
      }else if( this.comboShow.item_type == 4 ){
        this.comboShow.taste_holiday = this.comboObj.days
      }else if (this.comboShow.item_type == 30) {
        this.comboShow.taste_weekend_day = this.comboObj.days
      }else if (this.comboShow.item_type == 40) {
        this.comboShow.taste_holiday_weekend_day = this.comboObj.days
      }
    //  this.comboShow.item_type == 3 || this.comboShow.item_type == 30
    //    ? (this.comboShow.taste_day = this.comboObj.days)
    //    : (this.comboShow.taste_holiday = this.comboObj.days);
      this.isCreate = true
    },
    async postCombo() {
      var ret = await this.$http.improveItem(this.comboShow)
      if (ret.code == 200) {
        this.$message({
          type: 'success',
          message: '操作成功'
        })
        this.$router.go(-1)
      }
    }
  }
  // watch: {}
}
</script>
<style lang="scss" scoped>
.taste-combo {
  .data-form-title {
    font-size: 20px;
    margin-bottom: 30px;
    color: $color_black;
  }
  .self-table {
    .table-name {
      height: 60px;
      background-color: $color_blue;
      opacity: 0.7;
      line-height: 60px;
      color: #fff;
      text-align: center;
      font-size: 14px;
    }
    .el-button {
      margin-top: 40px;
    }
  }
  ::v-deep .el-form {
    .el-form-item {
      margin-bottom: 20px;
      color: $color_black;
      .el-form-item__label {
        margin-right: 20px;
        padding-right: 0;
        &:before {
          color: $color_blue;
        }
      }
      i {
        font-style: normal;
        margin-left: 10px;
      }
      b {
        font-weight: normal;
        color: $color_normal;
      }
    }
    .el-input {
      width: 180px;
    }
  }
}
.el-button {
  width: 120px;
  height: 40px;
}
</style>
